import React from 'react';
import TeachingScheduleComponent from '../../modules/exam/ExamScheduleList';

const ExamSchedulerPage = () => {
    return (
        <div className="container-fluid">
            <TeachingScheduleComponent />
        </div>
    );
};

export default ExamSchedulerPage;